import React from 'react';
import { styled } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';
import { PerksCreationStepper, PerksCreationStepperProps } from '../PerksCreationStepper';

interface PerksCreationModalProps extends PerksCreationStepperProps {
    open: boolean;
}

const StyledMuiModal = styled(MuiModal)(({ theme }) => ({
    width: `calc(100% - ${theme.spacing(4)})`,
    maxWidth: theme.spacing(160)
}));

export const PerksCreationModal: React.FC<PerksCreationModalProps> = props => {
    const { open, onClose, ...rest } = props;
    return (
        <StyledMuiModal open={open} onClose={onClose}>
            <PerksCreationStepper onClose={onClose} {...rest} />
        </StyledMuiModal>
    );
};
